import { TabProps } from '../types/types';

export const Tabs: TabProps[] = [
  { name: 'home', label: { vi: 'Trang chủ', en: 'Home' }, path: '/' },
  { name: 'news', label: { vi: 'Tin tức', en: 'News' }, path: '/news' },
  { name: 'dojo', label: { vi: 'Võ đường', en: 'Dojo' }, path: '/dojo' }
]

